import * as React from 'react';
import { Box, Typography, InputAdornment } from '@mui/material';
import SvgIcon from '@mui/material/SvgIcon';

export function TextInputIcon() {
  return (
    <SvgIcon>
      <svg 
        width="24" 
        height="24" 
        viewBox="0 0 24 24" 
        fill="none" 
        xmlns="http://www.w3.org/2000/svg"
      >
        <text 
          x="12" 
          y="15" 
          textAnchor="middle" 
          fill="#4F4F4F" 
          fontFamily="Arial" 
          fontSize="12"
        >
          A
        </text>
        <line 
          x1="15" 
          y1="8" 
          x2="15" 
          y2="16" 
          stroke="#4F4F4F" 
          strokeWidth="2" 
          strokeOpacity="0.7"
        />
      </svg>
    </SvgIcon>
  );
}

export function AInputIcon() {
  return (
    <InputAdornment position="start">
      <Box 
        sx={{ 
          display: 'flex', 
          alignItems: 'center', 
          marginRight: '10px',
          position: 'relative'
        }}
      >
        <Typography variant="body1" sx={{ color: '#4F4F4F' }}>A</Typography>
        <Box 
          sx={{
            width: '2px', 
            height: '20px', 
            backgroundColor: '#4F4F4F', 
            marginLeft: '3px',
            opacity: 0.7
          }}
        />
      </Box>
    </InputAdornment>
  );
}

// You can add more unique icons here in the future
export function AnyOtherUniqueIcon() {
  // Placeholder for future icons
  return null;
}